import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "rebass";
import { Rnd, RndResizeCallback } from "react-rnd";

import { getWidths } from "../../../store/modules/display/selectors";
import { setLeftSideWidth, /*setRightSideWidth*/ } from "../../../store/modules/display/actions";

import commonSettings, { leftRange, /*rightRange*/ } from "./rndSettings";

export const WidthControl: React.FC = () => {
  const { widthLeft, /*widthRight*/ } = useSelector(getWidths);
  const dispatch = useDispatch();
  const onResizeLeft = useCallback<RndResizeCallback>((e, dir, ref) => {
    const { style: { width } } = ref;

    if (width) {
      dispatch(setLeftSideWidth(parseFloat(width)));
    }
  }, [dispatch]);

  /*const onResizeRight = useCallback<RndResizeCallback>((e, dir, ref) => {
    const { style: { width } } = ref;

    if (width) {
      dispatch(setRightSideWidth(100 - parseFloat(width)));
    }
  }, [dispatch]);*/

  return (
    <Box css="position: absolute; top: 0; bottom: 0; left: 0; right: 0; pointer-events: none;">
      <Rnd
        {...commonSettings}
        {...leftRange}
        size={{ width: `${widthLeft}%`, height: "100%" }}
        onResize={onResizeLeft}
      />

      {/*<Rnd
        {...commonSettings}
        {...rightRange}
        size={{ width: `${widthRight}%`, height: "100%" }}
        onResize={onResizeRight}
      />*/}
    </Box>
  );
};
